import styled from 'styled-components'

export const Title = styled.span`
  font-size: 15px;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-weight: bolder;
  margin-top: 10px;
`

export const Text = styled.span`
  font-size: 15px;
  white-space: pre-line;
`
export const Li = styled.li`font-size: 15px;`
export const Ul = styled.ul`margin-left: 25px;`
export const P = styled.div`margin: 1em;`
